<template>
  <div class="add-note-modal">
    <div v-if="loadModal" class="modal modal-mask">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header div-responsive">
            <div class="modal-title">
              <h1 v-if="!isBilling">{{ isEdit ? 'Edit Note' : 'Add Note' }}</h1>
              <h1 v-else>{{ isEdit ? 'Edit Billing Note' : 'Add Billing Note' }}</h1>
            </div>
            <button type="button" class="close-icon" @click="handleModal($event)" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body div-responsive">
            <form style="font-size: 14px;">
              <div v-if="fromProps === 'admin' && !isBilling" class="form-group box-center">
                <label class="pr-5 m-0">Internal only?</label>
                <input type="radio" :value="0" v-model="internalOnly" v-if="fromProps === 'admin'" /><p v-if="fromProps === 'admin'" class="pl-1">No</p>
                <input style="margin-left: 12px;" type="radio" :value="1" v-model="internalOnly" v-if="fromProps === 'admin'" /><p v-if="fromProps === 'admin'" class="pl-1">Yes</p>
              </div>
              <div class="form-group">
                <textarea rows="4" type="text" @keydown.enter.prevent="callSave" v-model="note" class="textbox" :class="hasError && errorMessage ? 'is-invalid' : ''" maxlength="1000" placeholder="Enter a note" />
                <div v-if="hasError && errorMessage" class="text-danger">{{ errorMessage }}</div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="icon-group right-float-element">
                    <v-btn class="white-button" @click="handleModal($event)" dark>Cancel</v-btn>
                    <v-btn @click="callSave" id="savebutton" dark>Save</v-btn>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utilities from '@/assets/js/utilities'
  import store from "@/store";

  export default {
    name: 'AddNoteModal',
    props: ['bookingProps', 'fromProps', 'isBilling'],
    data() {
      return {
        hasError: false,
        loadModal: false,
        note: '',
        isNoteFromClient: false,
        isEdit: false,
        editNote: '',
        clientNote: '',
        isNewNote: false,
        isEditClient: false,
        isNewBooking: false,
        isEditClientNote: false,
        internalOnly: 0,
      }
    },
    computed: {
      user() {
        return this.$store.getters['user/getUser'];
      },
      errorMessage() {
        return this.validateNoteForSubmit()
      }
    },
    methods: {
      handleModal(e) {
        this.loadModal = !this.loadModal
        if (this.loadModal) {
          $('html').addClass('modal-mask-open')
        } else {
          this.note = ''
          $('html').removeClass('modal-mask-open')
        }
      },
      addNoteToBooking() {
        this.internalOnly = 0
        this.isNewNote = true
      },
      addNewNote(v) {
        this.isEdit = false
        this.editNote = ''
        this.note = ''
        this.internalOnly = v !== undefined ? v : 1
      },
      editCurrentNote(note, isNewBooking = false) {
        this.isEdit = true
        this.isNewBooking = isNewBooking
        if (this.isNewBooking) {
          this.note = note
        } else {
          this.editNote = note
          this.note = this.editNote.Note
        }
      },

      editClientNote(note, isEditClientNote) {
        this.isEdit = true
        this.isNewNote = false
        this.isEditClientNote = isEditClientNote
        this.clientNote = note
        this.note = this.clientNote.note
      },

      callPostBookingNoteAPI() {
        var params = {
          Note: this.note.trim(),
          NoteDateTime: moment().format('YYYY-MM-DD HH:mm:ss'),
          BookingID: this.bookingProps.BookingID,
        }
        if(!this.isBilling) params.InternalOnly = this.internalOnly
        // if (params.IsMainEdit == 0) {
        //   params.BookingDateTime = this.$parent.booking.bookingDateTime
        //   params.SpecialistName = this.$parent.booking.specialistFullName
        //   params.CaseOwnerName = typeof(this.$parent.getCaseOwnerName) === 'string' ? this.$parent.getCaseOwnerName :  this.$parent.getCaseOwnerName()
        //   params.ClientName = this.$parent.booking.clientName + ' - ' + this.$parent.booking.branchName
        //   params.BookingTypeName = this.$parent.booking.bookingTypeName
        //   params.LocationName = this.$parent.getLocationName(this.$parent.booking.locationId)
        //   params.IsAdmin = true
        // }
        var callback = (response) => {
          try {
            var allNote = this.isBilling ? this.bookingProps.billingNotes : this.bookingProps.bookingNotes
            console.log(allNote)
            var newNote = {}
            newNote = {
              Note: this.note.trim(),
              NoteDateTime: window.moment().format('YYYY-MM-DD HH:mm:ss'),
              id: response,
              Username: this.user.name,
              UsernameLog: this.user.name,
              UserID: this.user.id,
              Deleted: false,
            }
            if(!this.isBilling) {
              newNote.InternalOnly = this.internalOnly
              newNote.BookingNoteID = response
            } else {
              newNote.BillingNoteID = response
            }
            allNote.push(newNote)
            //this.$parent.getOriginalBooking()
            if(this.isBilling) {
              this.$parent.booking.billingNotes = allNote
              this.$parent.setBillingNoteAndAction()
            } else {
              this.$parent.booking.bookingNotes = allNote
              this.$parent.setBookingNoteAndAction()
            }
            this.$parent.noteKey += 1
            this.handleModal()
          } catch (e) {}
        }
        $('#savebutton').prop('disabled', false)
        return this.isBilling ? utilities.postBillingNote(params, callback) : utilities.postBookingNote(params, callback)
      },

      callPutBookingNoteAPI() {
        var params = {
          Note: this.note.trim(),
          NoteDateTime: window.moment().format('YYYY-MM-DD HH:mm:ss'),
          BookingID: this.bookingProps.BookingID,
        }

        if(!this.isBilling) {
          params.InternalOnly = this.internalOnly
        }

        var callback = (response) => {
          this.editNote.Note = this.note.trim()
          this.editNote.internalOnly = this.internalOnly
          if (this.isEditClient) {
            params.BookingNoteID = this.isBilling ? this.editNote.BillingNoteID : this.editNote.BookingNoteID
            this.isBilling ? this.$parent.setBillingNoteAndAction(params) : this.$parent.setBookingNoteAndAction(params)
          }
          console.log('note updated!')
          this.$parent.noteKey += 1
          this.handleModal()
        }
        $('#savebutton').prop('disabled', false)
        return this.isBilling ? utilities.putBillingNote(this.editNote.BillingNoteID, params, callback) : utilities.putBookingNote(this.editNote.BookingNoteID, params, callback)
      },

      async callPutClientNoteAPI() {
        if(this.$parent.curTab === 1 && this.$parent.updateAlert) {
          this.$parent.updateAlert(this.note.trim())
          this.handleModal()
          return
        }
        var params = {
          Note: this.note.trim(),
          InternalOnly: this.internalOnly,
        }
        var callback = (response) => {
          this.$parent.getClientNotes()
          this.handleModal()
        }
        $('#savebutton').prop('disabled', false)
        return await utilities.putClientNote(this.clientNote.clientNoteId, params, callback)
      },

      async saveNoteToBooking() {
        this.$parent.adminEditNoteToBooking &&  this.$parent.adminEditNoteToBooking(this.note.trim())
        if (!this.isBilling) {
          console.log('add notes to client')
          this.$parent.addNoteToBooking && await this.$parent.addNoteToBooking(this.note.trim())
          this.handleModal()
        } else {
          this.handleModal()
        }
        $('#savebutton').prop('disabled', false)
      },

      validateNoteForSubmit() {
        const s = String(this.note || '').trim()
        if (this.isEditClientNote) {
          if (!s) {
            return 'Please enter note text.'
          }
          if (!utilities.validateInput(s)) {
            return 'Please do not start with \'=\' or  \'-\'  or  \'+\' or  \'@\' or  \'%\' and do not contains \'--\' or \'||\' or \'@@\''
          }
          return null
        }
        if (this.fromProps === 'travel') {
          if (!s) {
            return null
          }
          const e = utilities.getBookingRequestNoteError(s)
          return e || null
        }
        if (!s) {
          return 'Please enter note text.'
        }
        const fmt = utilities.getBookingRequestNoteError(s)
        return fmt || null
      },
      async callSave() {
        if( this.$store.getters["loading/getLoadComponent"]) {
          return
        }
        this.hasError = false
        this.note = String(this.note || '').trim()
        if (this.errorMessage) {
          this.hasError = true
          return
        }
        $('#savebutton').prop('disabled', true)
        if (this.fromProps == undefined || this.fromProps == 'admin') {
          await this.$store.dispatch('loading/setLoadComponent', true)
          if (this.isNewNote) {
            if(this.isBilling) {
              this.$parent.booking.billingNotes.push({
                note: this.note.trim(),
                noteDateTime: moment().format('YYYY-MM-DD HH:mm:ss'),
                userName: this.$parent.user.name,
                userId: this.$parent.user.id
              })
            } else {
              if(this.$parent.booking && !this.$parent.addNoteToBooking) {
                this.$parent.booking.bookingNotes.push({
                  note: this.note.trim(),
                  noteDateTime: moment().format('YYYY-MM-DD HH:mm:ss'),
                  userName: this.$parent.user.name,
                  internalOnly: this.internalOnly,
                  userId: this.$parent.user.id
                })
              }
            }
            this.saveNoteToBooking(this.note)
          } else if (this.isEdit) {
            if (this.isNewBooking) {
              this.saveNoteToBooking(this.note)
            } else if (this.isEditClientNote) {
              await this.callPutClientNoteAPI()
            } else {
              await this.callPutBookingNoteAPI()
            }
          } else {
            await this.callPostBookingNoteAPI()
          }
          this.$store.dispatch('loading/setLoadComponent', false)
        } else if (this.fromProps == 'supplementaryService') {
          this.saveNoteToBooking(this.note)
        } else {
          if (this.fromProps == 'create') {
            this.$parent.booking.bookingNotes.push({
              note: this.note.trim(),
              noteDateTime: moment().format('YYYY-MM-DD HH:mm:ss'),
              userName: this.$parent.user.name,
              userId: this.$parent.user.id
            })
          }
          if (this.fromProps == 'travel') {
            if(this.$parent.travelItinerary.specialistTravelItineraryId != '') {
              this.$parent.travelItinerary.notes = this.note.trim()
              this.saveTravelNote()
            }
            else this.$parent.note = this.note.trim()
          }
          this.handleModal()
        }
      },
      async saveTravelNote() {
        var params = {
          UserID: this.user.id,
          Username: this.user.name,
          Notes: this.note.trim(),
          SpecialistTravelItineraryID: this.$parent.travelItinerary.specialistTravelItineraryId
        }
        await utilities.putTravelItinerary(params)
      },
    },
    mounted() {},
  }
</script>
